import React, { FC } from "react";
import { useParams } from "react-router";
import { Col, Container, Row } from "reactstrap";
import CollapsibleCard from "src/components/CollapsibleCard/CollapsibleCard";
import CopyToClipboard from "src/components/CopyToClipboard/CopyToClipboard";
import { IconName } from "src/components/Icon/Icon";
import * as S from "../../constants/StringConstants";
import "./CompanyQuotesWidget.scss";

interface RouteParams {
  id: string;
}

const CompanyQuotesWidget: FC = () => {
  const { id: companyID } = useParams<RouteParams>();
  const companyUrl = companyID ? `${S.CWQ_COMPANY_URL}${companyID}` : "";

  return (
    <CollapsibleCard title={S.PD_BROKER_QUOTES_LINKS_HEADER} iconName={IconName.BrokerBuilderQuotes} defaultOpen={true}>
      <Container>
        {companyID && (
          <>
            <Row>
              <Col className="link-row">
                <a className="linkItem" href={companyUrl} target="_blank" rel="noreferrer">
                  {S.CQW_COMPANY}
                </a>
                <CopyToClipboard textToCopy={companyUrl} />
              </Col>
            </Row>
            <Row className="card-separator" />
          </>
        )}
      </Container>
    </CollapsibleCard>
  );
};

export default CompanyQuotesWidget;
